import {RouteName} from "../router/routes";
import {router} from "../containers/AppContainer";

/**
 * navigate to route
 * @param {RouteName} routeName
 * @param {any} params
 */
export function navigateTo(routeName: RouteName, params?: any) {
  params
    ? router.navigate(routeName, params)
    : router.navigate(routeName)
}

/**
 * change window location href
 * @param {string} url
 * @param {boolean} withPrefix
 */
export function changeWindowLocation(url: string, withPrefix?: boolean) {
  withPrefix
    ? window.location.href = `${process.env.PUBLIC_URL}/${url}`
    : window.location.href = url
}

/**
 * open link in new window
 * @param {string} url
 */
export function openInNewTab(url: string) {
  window.open(url, '_blank')
}